import { create } from 'zustand';
import type { CelebrationData } from '@/types';

// 'sale'     → the normal per-sale fireworks + TTS overlay
// 'champion' → the special one-time "We Are The Champions" milestone show
//              (Queen song + dedicated video, lasts for the song's length)
export type CelebrationVariant = 'sale' | 'champion';

interface CelebrationState {
  isActive: boolean;
  variant: CelebrationVariant;
  data: CelebrationData | null;
  trigger: (data: CelebrationData) => void;
  triggerChampion: () => void;
  dismiss: () => void;
}

export const useCelebrationStore = create<CelebrationState>((set) => ({
  isActive: false,
  variant: 'sale',
  data: null,

  trigger: (data) => set({ isActive: true, variant: 'sale', data }),

  triggerChampion: () => set({ isActive: true, variant: 'champion', data: null }),

  dismiss: () => set({ isActive: false, variant: 'sale', data: null }),
}));
